import React from "react";
import InputTextArea from "../inputTextArea/InputTextArea";
import { systemConstants } from "../../../constants";

const Description = (props) => {
  const { disabled } = props;
  return (
    <InputTextArea
      maxLength={systemConstants.TEXTAREA_MAX_LENGTH}
      name="description"
      label="Description (Optional)"
      placeHolder="Enter Description"
      className={"border"}
      disabled={disabled}
    />
  );
};

export default Description;
